import React, { useState ,useEffect} from "react";
import pwclogo from "../../../assets/images/tata_motors_logo.png";
import "../../../styles/login.css";
import axios from "axios";
import {Select} from "@appkit4/react-components/select"
import PropTypes from "prop-types";
import poweredByLogo from "../../../assets/images/poweredByLogo.png"

function OrganizationsForm(props) {
  const [orgs, setOrgs] = useState("");
  const [userroles,setUserroles]= useState((sessionStorage.getItem("idamLogin") === "true")?[{}]:props.location.state.userroles)


 

useEffect(() => {
  if(sessionStorage.getItem("idamLogin") === "true"){
    let roleID  = document.cookie.split("; ").find(row => row.startsWith('_role_id=')).split('=')[1];
    let userID  = document.cookie.split("; ").find(row => row.startsWith('userId=')).split('=')[1];
    let Org  = document.cookie.split("; ").find(row => row.startsWith('org_name=')).split('=')[1];
    let orgID  = document.cookie.split("; ").find(row => row.startsWith('_org_id=')).split('=')[1];
    let loggedIN  = document.cookie.split("; ").find(row => row.startsWith('loggedIn=')).split('=')[1];
    let jwt  = document.cookie.split("; ").find(row => row.startsWith('jwtToken=')).split('=')[1];
    sessionStorage.setItem("roleId", roleID);
    sessionStorage.setItem("userId", userID);
    sessionStorage.setItem("orgId", orgID);
    sessionStorage.setItem("loggedIn", loggedIN);
    sessionStorage.setItem("jwtToken", jwt);
      axios.defaults.headers.common["roleid"] = roleID;
      axios.defaults.headers.common["userid"] = userID;
      axios.defaults.headers.common["orgid"] = orgID;
      let roleData=[{}]
     roleData[0]._role_id=Number (roleID)
     roleData[0]._org_id= Number (orgID)
     roleData[0].userID=userID
     roleData[0].org_name=Org
    setUserroles(roleData)
  }
  if (!userroles) {
    props.history.push("/login");
  }

}, []);


  const handleChange = () => {
    if (userroles[0]._role_id === 2) {
      props.history.push("/dashboard");
    } else if (userroles[0]._role_id === 1) {
      props.history.push("/thirdpartyRequestManagement");
    } else if (userroles[0]._role_id === 3) {
      props.history.push("/dashboard");
    } else if (userroles[0]._role_id === 4) {
      props.history.push("/dashboard");    
    }
    
  };

  return (
   
    <div className="loginBackground">
      <div className="container">
        <div className="row">
          <div className="row fixed-top login-bgm-alignment">
            <div className="ps-4">
              <img src={pwclogo}  alt="" height="80px"></img>
            </div>
            {/* <div className="vertical-line-header"></div>
            <div className="pt-3">
              <p className="header-text">TPRM</p>
            </div> */}
          </div>
          <div className="col-lg-7 lf-div">
            <h2 className="wt login-welcome">Welcome to the</h2>
            <h3 className="login-tprm">Third Party Cybersecurity Assessment Programme</h3>
            <p className="login-paragraph">
            for Tata Motors Limited - A Web Based Assessment Questionnaire.
              {/* It is a comprehensive tool built to address the growing
              challenges of managing a third party volume within an
              organization's TPRM landscape. */}
            </p>
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-4 loginBackgroundColor OrganizationHover rgt-div ">
            <div className="my-5">
              <div className="card-body ">
                <div>
                  <div className="login-text userEmailField">Please select organization</div>
                
                  <div className="empty-div"></div>
                  <div className="userEmailField">
                  <Select
                  data={userroles}
                  value={orgs}
                  valueKey="_role_id"
                  labelKey="org_name"
                  onSelect={handleChange}
                  placeholder="Select organization"
                  ></Select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row  m-t-20">
          <div className="col-lg-10 "></div>
               <div className="col-lg-2 ">
               <img src={poweredByLogo} className="pwcPoweredByforgot" alt=""></img>
               </div>
              
             </div>
      </div>
    </div>
  );
}
OrganizationsForm.propTypes = {
  location: PropTypes.any,
  history: PropTypes.any
}
export default OrganizationsForm;
